import { API_BASE_URL } from '@/api/config';

// Share absolute public URLs over LiveKit: a recipient may be a native app
// using a different origin from the teacher's browser.
export function liveDocumentUrl(path, manifestUrl) {
  if (!path) throw new Error('Missing document URL');
  const apiBase = new URL(API_BASE_URL || '/api', window.location.origin);
  return new URL(path, manifestUrl || apiBase.origin).href;
}

export function documentShareError(error, stage = 'upload') {
  if (stage === 'prepare' && error?.response?.status === 404) {
    return 'The PDF is uploaded, but page sharing is unavailable. Restart or update the backend and select the PDF from My Documents.';
  }
  const detail = error?.response?.data?.error || error?.response?.data?.detail;
  if (typeof detail === 'string' && error?.response?.status < 500) return detail.slice(0, 300);
  if (!error?.response) return 'Cannot reach the server. Check your connection and API address, then try again.';
  return stage === 'prepare'
    ? 'The PDF is uploaded, but its pages could not be prepared. Try selecting it from My Documents.'
    : 'The document could not be uploaded. Please try again.';
}
